import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {SocialShareWithTitleOwnProps, SocialShareWithTitleRuntimeProps} from './interfaces'
import {SocialShareWithTitle as Presentation} from './with-title'

const mapRuntime = ({state}: DetailsPageAppProps): SocialShareWithTitleRuntimeProps => {
  const componentSettings = state.component.settings

  return {
    componentSettings,
    mobile: isMobile(state),
  }
}

export const SocialShareWithTitle = connect<SocialShareWithTitleOwnProps, SocialShareWithTitleRuntimeProps>(mapRuntime)(
  Presentation,
)
export * from './interfaces'
